import * as Yup from "yup";
import React, { useState } from "react";
import { Formik } from "formik";

import ContainedButton from "components/layout/form/containedButton";
import ModalIdentification from "components/MI/minha-conta/ModalIdentification";

import {
  ButtonContainer,
  FieldName,
  FormContainer,
  Input,
  InputsContainer,
  Option,
  Select,
  TextArea,
} from "./styles";

const Form = ({ handleSubmit, months }: any): JSX.Element => {
  const [openModalIdentification, setOpenModalIdentification] = useState(false);

  const validationSchema = (): any =>
    Yup.object().shape({
      months: Yup.string().required("Mês necessário"),
      files: Yup.mixed(),
      description: Yup.string(),
    });

  const toggleModalIdentification = (): void => {
    setOpenModalIdentification((prevState) => !prevState);
  };

  return (
    <>
      <Formik
        initialValues={{
          files: [],
          months: [],
          description: "",
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        render={({
          handleChange,
          handleBlur,
          values,
          isValid,
          setFieldValue,
          isSubmitting,
        }) => (
          <FormContainer>
            <InputsContainer>
              <Input>
                <FieldName>
                  Fatura(s) de qual(is) mês(es) você deseja analisar?
                </FieldName>
                <Select
                  name="months"
                  placeholder="Selecionar mês(es)"
                  value={values.months}
                  onChange={(e) => setFieldValue("months", e)}
                  onBlur={handleBlur}
                  disabled={isSubmitting}
                  filterOption={false}
                  backfill={false}
                  showSearch={false}
                  tokenSeparators={[","]}
                  mode="multiple"
                  isSelected={!!values?.months?.length}
                >
                  {months?.map((item) => (
                    <Option key={item?.value} value={item?.value}>
                      {item?.label}
                    </Option>
                  ))}
                </Select>
              </Input>
              <Input>
                <FieldName>Observações:</FieldName>
                <TextArea
                  name="description"
                  value={values.description}
                  onChange={(e) => {
                    e.target.value = e.target.value.replace(/^\s+/, "");
                    handleChange(e);
                  }}
                  onBlur={handleBlur}
                  disabled={isSubmitting}
                />
              </Input>
            </InputsContainer>
            <ButtonContainer>
              <ContainedButton
                type="submit"
                disabled={!isValid || isSubmitting}
                loading={isSubmitting}
              >
                Enviar
              </ContainedButton>
            </ButtonContainer>
          </FormContainer>
        )}
      />
      <ModalIdentification
        open={openModalIdentification}
        toggleModal={toggleModalIdentification}
      />
    </>
  );
};

export default Form;
